export const services_data = [
  {
    id: "1",
    link: "transguard",
    title: "transguard",
    description:
      "transguardDescription",
    information: [
      {
        id: "1",
        title: `blsBlackList`,
        button:'button',
        img: require('../pictures/tg/bls.png'),
        fulldescription:`blsBlackListDescriptionFull`,
        description:"blsBlackListDescripton",
      },
      {
        id: "2",
        title: `fmrReports`,
        img: require('../pictures/tg/FMR.png'),
        button:'button',
        fulldescription:"fmrDescriptionFull",
        description:"fmrDescription",
      },
      {
        id: "3",
        title: "kycCustomerRisk",
        img: require('../pictures/tg/KYC.png'),
        button:'button',
        fulldescription:"kycCustomerRiskDescriptionFull",
        description:
          "kycCustomerRiskDescription",
      },
    ],
  },
  {
    id: "2",
    link: "swift",
    title: "serviceSwift",
    description:"serviceDescription",
    information: [
      {
        id: "1",
        title: `swiftComunication`,
        img: require('../pictures/swift/backup_line.png'),
        button:'button',
        fulldescription:`swiftComunicationFullDescription`,
        description:
          "swiftComunicationDescription",
      },
      {
        id: "2",
        title: "swiftComunicationInfrastructure",
        img: require('../pictures/swift/communication.png'),
        button:'button',
        fulldescription:`swiftComunicationInfrastructureDescriptionFull`,
        description:
          "swiftComunicationInfrastructureDescription",
      },
      {
        id: "3",
        title: `swiftFullInfrastructure`,
        img: require('../pictures/swift/full.png'),
        button:'button',
        fulldescription:`swiftFullInfrastructureDescriptionFull`,
        description:
          "swiftFullInfrastructureDescription",
      },
    ],
  },
];

export const services_info = [
  {
    id: "1",
    main_title: "TransGuard",
    title: "BLS - Black List Screening",
    description:
      "კომპონენტრი რამდენიმე მძლავრი ალგორითმისგან შედგება. მის მიზანს, ჩანაწერსა (ტექსტის) და შავ სიას შორის დამთხვევის გამოვლენა წარმოადგნს. კომპონენტი Thomson Reuters-ის სიების Premium Plus პაკეტს იყენებს. პროდუქტი, 600-ზე მეტ კრიმინალურ და პოლიტიკურად აქტიურ პირთა სიას მოიცავს. ისინი ავტორიტეტული საერთაშორისო ორგანიზაციებისა და ქვეყნების მიერაა შედგენილი. ბაზების განახლება დღეში ორჯერ ხორციელდება. სერვისს გააჩნია, ორი რეჟიმი: ავტომტური რეჟიმი - სისტემა დანერგილია მომხმარებლის მხარეს და ტრანზაქციაში ასახული ინფორმაციის შედარებას სხვადასხვა ტიპის (ე.წ. შავ და PEP) სიებთან უზრუნველყოფს. დამთხვევის გამოვლენის შემთხვევაში, ოპერაციის ჩერდება. ამის შემდეგ ოპერატორს საშუალება ეძლევა გაუშვას ან დაბლოკოს ტრანზაქცია. სერვისი მუშაობს რეალურ დროში. სისტემა უზრუნველყოფს, როგორც არსებული კლიენტების ბაზის, ასევე ახალი კლიენტების რეგისტრაციის პროცესის სრულ შემოწმებას. მექანიკური რეჟიმი - (ე.წ. ონლაინ იუზერი) სისტემა დანერგილია სერვის ბიუროს მხარეს და მომხმარებელს სერვისზე წვდომა მოშორებულად, ვებ-გვერდის საშუალებით გააჩნია. სიებში გადამოწმება სისტემაში (ფიზიკური/იურიდიული) პირის მონაცემების მექანიკური შეყვანით ხორციელდება.",
  },
  {
    id: "2",
    title: "FMR – Financial Monitoring Report",
    description:
      "საქართველოს ფინანსური მონიტორინგის სამსახურის მიერ მოთხოვნილი, საეჭვო და ზღვარს ზემოთ ოპერაციების/გარიგებების ავტომატურ გამოვლენას უზრუნველყოფს. FMR მომხმარებლის ინფრასტრუქტურაში ინერგება და მის ძირითად საოპერაციო სისტემასთან ინტეგრირდება, საიდანაც მას დღის მანძილზე შესრულებული ტრნზაქციები მიწეოდება. მათი ანალიზის საფუძველზე, ფმს რეგულაციების შესაბამისი ანგარიშგებათა ფორმები ავტომატურად იქმნება. სისტემა ფმს-ის ინფრასტრუქტურასთან არის ინტეგრირებული, რაც უკვე მომზადებული ანგარიშგების მარტივად გაგზავნის საშუალებას იძლევა.",
  },
  {
    id: "3",
    title: "KYC – Know Your Customer",
    description:
      "კომპონენტი საქართველოს ეროვნული ბანკის მიერ (უკანონო შემოსავლის ლეგალიზაციისა და ტერორიზმის დაფინანსების რისკის შეფასების მეთოდური სახელმძღვანელო) განსაზღვრული სტანდარტებით არის დამუშავებული. KYC ინერგება მომხმარებლის მხარეს და მისი ინტეგრირება ძირითად საოპერაციო სისტემასთან ხორციელდება. მისი მიზანს, კლიენტების ბაზების მართვა წარმოადგენს. რისკიანობის ანალიზი ინდივიდუალური და საერთაშორისო მიდგომების საფუძველზე ხდება. შესრულებული ტრანზაქციების ანალიზი კლიენტების დონეზე წარმოებს. მაქსიმალურად არის გამოყენებული რისკზე დაფუძნებული ისეთი მიდგომები როგორიცაა: • გეოგრაფიული რისკი • პროდუქტის / სერვისის მიწოდების რისკი • პროდუქტის / სერვისის რისკი • კლიენტის რისკი",
  },
  {
    id: "4",
    title: "NBR – National Bank Reporting",
    description:
      "საქართველოს ეროვნული ბანკის მიერ განსაზღვრული ოფსაიტ მატრიცის ავტომატურად შექმნას უზრუნველყოფს. ანგარიშგებათა შედგენის პროცესში, სისტემა როგორც ძირითადი საოპერაციო სისტემის, ასევე TransGuard-ის სხვა კომპონენტების (BLS, FMR, KYC) მიერ დამუშავებულ ინფორმაციას იყენებს. ინტერფეისი საანგარიშგებო პერიოდისა და კონრკეტული ანგარიშგების ფორმის არჩევის საშუალებას იძლევა (მაგ. სტატისტიკური ინფორმაცია საქართველოს ფინანსური მონიტორინგის სამსახურში გაგზავნილი ანგარიშგებების შესახებ). ფორმათა ჯგუფი, რომელტა ავტომატურად შევსება შეუძლებელია, მექანიკურ რედაქტირებას ექვემდებარება.",
  },
  {
    id: "5",
    title: "SWIFTRef",
    description:
      "მისი სერვერი სერვის ბიუროს ინფრასტრუქტურაში მდებარეობს. კომპონენტი მსოფლიო ფინანსური ინსტიტუტების საიდენტიფიკაციო მონაცემებს აერთიანებს, რაც ტრანზაქციის შექმნის დროს, საჭირო ინფორმაციის მოძიებას ამარტივებს. ინფორმაციის ავტორიზებული და ოფიციალური მომწოდებელია სვიფტი. მონაცემთა ბაზა, ყოველდღიურად განახლებადი, 5 ძირითადი პაკეტისგან (IBAN Plus, SEPA Plus, Bank Directory Plus, SSI Plus, CCH) შედგება. სისტემას გააჩნია ორი რეჟიმი: ავტომატური - მომხმარებლის საოპერაციო სისტემა SWIFTRef კატალოგთან ვებ-სერვისით ურთიერთქმედებს. შედეგად, ავტომატურად შესაძლოა შემოწმდეს ან/და შეივსოს ისეთი ინფორმაცია როგორიცაა: IBAN, BIC, კორესპოდენტები ვალუტის მიხედვით და ა.შ.. პროცესის ავტომატიზაცია მნიშვნელოვნად ამცირებს ტრანზაქციის დამუშავებისა და შესრულების დროს.",
  },
  {
    id: "6",
    title: "მექანიკური",
    description:
      "მომხმარებელი სერვისზე წვდომას, მოშორებულად, ვებ-გვერდის საშუალებით ახორციელებს. მონაცემების გადამოწმება, შესაბამის ველებში ინფორმაციის მექანიკურად შეყვანით წარმოებს. დამატებითი ინფორმაციის მიღების მიზნით გთხოვთ დაგვიკავშირდეთ.",
  },
];

export const service_title = [
  {
    id: "1",
    title: "TransGuard",
    description: `პროგრამულ უზრუნველყოფას წარმოადგენს. ის ერთმანეთთან დაკავშირებული რამდენიმე კომპონენტისგან შედგება.
         მათი გამოყენება შესაძლებელია, როგორც ერთად, ასევე ცალ-ცალკე. TransGuard-ის კომპონენტებია`,
  },
];

export const swift_info = [
  {
    id: "1",
    title: "SWIFT",
    description:
      "SWIFT გახლავთ მსოფლიოს საბანკო საფინანსო სატელეკომუნიკაციო საზოგადოება, რომლის საშუალებითაც ფინანსური სამყარო ძირითად საქმიანობას ახორციელებს. სისწრაფე, ხარისხი და სანდოობა, ეს ის ნიშნებია, რომლებიც SWIFT-ის სერვისებს ახასიათებს. აღნიშნული სატელეკომუნიკაციო არხის საშუალებით, სისტემაში მილიონობით ფინანსური მესიჯის გაცვლა ხორციელდება. SWIFT-ის ქსელში 215 ქვეყნისა და ტერიტორიის 10500-ზე მეტი საბანკო თუ საფინანსო ინსტიტუტია ჩართული.",
  },
  {
    id: "2",
    title: "GFTC 2007",
    description:
      "GFTC 2007 წლიდან მოღვაწეობს საქართველოს საფინანსო სექტორში და მომხმარებელს მაღალი ხარისხისა და სტაბილურობის პროგრამული პროდუქტებით უზრუნველყოფს. აღსანიშნავია ისიც, რომ კომპანია ფლობს SWIFT-ის მიერ მინიჭებულ სერვის-ბიუროს სტატუსს, რაც GFTC-ის მიერ გაწეული სერვისის მაღალ ხარისხს უსხვამს ხაზს.",
  },
  {
    id: "3",
    title: "GFTC მომხმარებელს სთავაზობს",
    description:
      "სერვის-ბიუროს სტატუსის შესაბამისად, GFTC მომხმარებელს სთავაზობს SWIFT-ის სრულ ინფრასტრუქტურას, რომელშიც გაერთიანებულია SWIFT-ის საკომუნიკაციო და საოპერაციო საშუალებები, როგორებიცაა: SWIFT Alliance Access (SAA), SWIFT Alliance Gateway (SAG); და SWIFTNet Link (SNL).",
  },
  {
    id: "4",
    title: "GFTC, SWIFT",
    description:
      "GFTC, SWIFT-ის სისტემის მიწოდების გარდა, საკმაოდ დიდ ყურადღებას უთმობს მომსახურების პერიოდში მის სრულ მხარდაჭერას. GFTC-ში მუშაობენ მაღალი კვალიფიკაციის მქონე თანამშრომლები, რომლებსაც SWIFT-ის მიერ არიან ლიცენირებულნი.",
  },
  {
    id: "5",
    title: "GFTC",
    description:
      "GFTC სერვის-ბიურო საბანკო ტექნოლოგიების სფეროში მუდმივად სიახლის ძიებაშია.",
  },
  {
    id: "6",
    title: "SWIFT",
    description:
      "SWIFT-ის მიმართულება ჩვენთვის უმნიშვნელოვანესი პრიორიტეტია, რამეთუ GFTC სტაბილურად განაგრძობს განვითარებას და აღნიშნული სისტემის სრულყოფას.",
  },
];

export const swift_title = [
  {
    id: "1",
    title: "Swift",
    description: `2014 წლიდან SWIFT საკუთარი პარტნიორების მუდმივ სერტიფიცირებას ახდენს. მიმდინარე პერიოდში, 2014 წლის წარმატებული სერტიფიცირების შემდეგ, სერვის ბიურო SWIFT-ის საპარტნიორო პროგრამის შემდეგ საფეხურს გადის.`,
  },
];
